import { Button, type ButtonProps } from "@/components/ui"

type PrizeGameActionProps = Omit<ButtonProps, "variant" | "tone" | "size" | "fullWidth" | "isLoading">

/** The prize game's primary action in the fixed game palette: ink, full width, with a spinner while `loading`. */
export function PrizeGameButton({ loading = false, ...rest }: PrizeGameActionProps & { loading?: boolean }) {
  return <Button {...rest} tone="game" size="md" fullWidth isLoading={loading} aria-busy={loading || undefined} />
}

/** The prize game's quiet secondary action ("Agora não", "Fechar") as a text link in muted ink. */
export function PrizeGameLink(props: PrizeGameActionProps) {
  return <Button {...props} variant="plain" tone="game" size="sm" fullWidth />
}
